<template>
    <div>
        <div class="header">
            <img alt="Aroma Check In" src="../assets/group-6.jpg" srcset="../assets/group-6@2x.jpg 2x, ../assets/group-6@3x.jpg 3x">
        </div>
        <h1 class="title-go-left">Välj konto<img alt="Add Profile" src="../assets/group-2.svg" class="add-profile" @click="addProfile"></h1>
        <br>
        <div>
            <!-- Profile list start -->
            <div v-for="(profile,i) in getProfiles" :key="i" >
                <div v-if="!showRemove">
                    <v-btn color="primary" block @click="$store.commit('setActiveProfile', i)">{{ profile.username }}</v-btn>
                    <br>
                </div>
                <div v-if="showRemove">
                    <v-btn color="error" block @click="$store.commit('removeProfile', i)">{{ profile.username }}</v-btn>
                    <br>
                </div>
            </div>
            <!-- Profile List End -->
            <div class="title-go-left">
                <v-btn @click="showRemoveProfile" class="secondary"><span style="color:#000000" v-if="showRemove">Klar</span><span style="color:#000000" v-if="!showRemove">Hantera profiler</span></v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Profiles',
        data(){
            return {
                showRemove: false,
                filter: ''
            }
        },
        computed: {
            getProfiles: function getProfiles(){
                this.profiles = this.$store.state.knownProfiles;
                var _this = this;

                var profiles = this.profiles.filter(function (profile){
                    return profile.username.toLowerCase().includes(_this.filter.toLowerCase());
                });

                if (this.sort == 'views') {
                    return profile.sort(function (a, b) {
                        return b.views - a.views;
                    });
                } else {
                    return profiles;
                }
            }
        },
        methods: {
            addProfile(){
                this.$router.push('Add_Profile');
            },
            showRemoveProfile(){
                this.showRemove = !this.showRemove;
            },
            removeProfile(i){
                if (window.confirm("Delete Profile?")){
                    this.$store.state.knownProfiles.splice(i, 1);
                }
            }
        },
        created: function(){
            this.$store.state.currentCustomers = [];
            this.$store.state.deliveries = [];
            this.$store.state.distributors = [];
            this.$store.state.loggingIn = false;
        }
    }
</script>

<style>
    body {
        margin:0;
        padding:0;
        font-family: 'Roboto', sans-serif;
    }

    .title-go-left {
        text-align: left!important;
        line-height: 1.5;
    }

    .add-profile {
        height: 40px;
        width: 40px;
        float: right;
    }

</style>



// WEBPACK FOOTER //
// src/components/Profiles.vue